import { render, staticRenderFns } from "./ProductPrepayment.vue?vue&type=template&id=166e5288&scoped=true&"
import script from "./ProductPrepayment.vue?vue&type=script&lang=ts&"
export * from "./ProductPrepayment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166e5288",
  null
  
)

export default component.exports